<template>
  <v-tooltip :disabled="!tooltipText" top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        :class="classBtn"
        :block="block"
        :color="color"
        :disabled="disabled"
        :icon="!!icon && !label"
        :label="label"
        :loading="loading"
        :outlined="icon && !!label"
        :small="small"
        :text="!icon"
        :type="type"
        rounded
        v-on="on"
        @click="$emit('click', $event)"
      >
        <v-icon
          :class="{ rotate: rotateIcon }"
          v-if="icon"
          :left="!!label"
          :center="!label"
        >
          {{ icon }}
        </v-icon>
        <span v-if="label" v-text="label" />
      </v-btn>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CPTBtn",
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    classBtn: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: null,
    },
    rotateIcon: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.rotate {
  transform: rotate(45deg);
}
</style>
